import { NgIf } from '@angular/common';
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Any, EmrButtonComponent, EmrModalComponent } from 'emr-ng-shared';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class EventArgs {
  modalRef: BsModalRef;
  hasError: boolean;
  closeOnOk: boolean;
}

@Component({
    selector: 'app-error-message-response',
    templateUrl: './error-message-response.component.html',
    styleUrls: ['./error-message-response.component.css'],
    standalone: true,
    imports: [EmrModalComponent, NgIf, EmrButtonComponent]
  })

  export class ErrorMessageResponseComponent {
    @Output() ok = new EventEmitter<EventArgs>();
    headerTitle: string;

    showCloseButton: false
    hasError = false;
    errorMessage: string = null;
    closeOnOk: boolean;
    debugErrorMessage = null;
    sucessMessage = null;

    constructor(public bsModalRef: BsModalRef) {}

    onOkClick() {
      const args = new EventArgs();
      args.modalRef = this.bsModalRef;
      args.hasError = this.hasError;
      args.closeOnOk = this.closeOnOk;

      this.ok.emit(args);

      this.bsModalRef.hide();
    }
  }
